import { useConfigQuery } from "@hooks";

import * as Apis from "../api";

const useAccountingQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default useAccountingQuery;
